import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Typography, useTheme } from "@mui/material";
import "./index.css";
import { CustomButton } from "../../../../../components/Button";

type Anchor = "bottom";

export default function AutomationsDrawer({
  openDrawer,
  setAutomationDrawerOpen,
}: {
  openDrawer?: boolean;
  setAutomationDrawerOpen: (event: boolean) => void;
}) {
  const [open, setOpen] = React.useState(openDrawer);
  const theme = useTheme();

  const toggleDrawer =
    () => (event: React.KeyboardEvent | React.MouseEvent) => {
      setOpen(!open);
      setAutomationDrawerOpen(false);
    };

  const actions = ["Send an email", "Post on socials", "Turn on AC"];

  const list = (anchor: Anchor) => (
    <Box
      sx={{
        borderRadius: "10px",
        height: "100%",
        textAlign: "center",
        padding: "10px",
        backgroundColor: theme.palette.background.default,
      }}
      color="secondary"
      role="presentation"
      onClick={toggleDrawer()}
      onKeyDown={toggleDrawer()}
    >
      <Typography color="secondary" fontWeight={800} fontSize={26}>
        Automations
      </Typography>
      <Typography color="secondary">
        Automations list connected to BO
      </Typography>
      {actions.map((action, i) => {
        return (
          <div className="action" key={i}>
            {action}
          </div>
        );
      })}
      <div className="justify-center">
        <CustomButton
          text={"Close"}
          submit={() => setOpen(false)}
          bgcolor={theme.palette.background.default}
          color="rgba(33, 143, 84, 1)"
          border="1px solid rgba(33, 143, 84, 1)"
          fontWeight="bold"
          borderRadius="8px"
          width="40%"
        />
      </div>
    </Box>
  );

  return (
    <div>
      <React.Fragment key={"bottom"}>
        <Drawer
          anchor={"bottom"}
          open={open}
          onClose={toggleDrawer()}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "80%", sm: "50%" },
              borderRadius: "10px",
              left: { xs: "9%", sm: "25%" },
              height: "auto",
              boxShadow: "-1px -1px 2px #222 !important",
            },
          }}
        >
          {list("bottom")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
